import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoDocumentoFirma, TipoDocumentoFirmaProps } from '../../interfaces/catalogos/TipoDocumentoFirmaInterface';

export const TipoDocumentoFirmas = () => {

    return new Promise<TipoDocumentoFirmaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoDocumentoFirma/', token)
            .then( ({ data } : { data : TipoDocumentoFirmaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoDocumentoFirma = () => {

    return new Promise<TipoDocumentoFirmaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoDocumentoFirma/ObtenerTipoDocumentoFirmas', token)
            .then( ({ data } : { data : TipoDocumentoFirmaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoDocumentoFirma = ( params: TipoDocumentoFirmaProps ) => {

    return new Promise<TipoDocumentoFirmaProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoDocumentoFirma/Actualizar', params, token)
            .then( ({ data } : { data : TipoDocumentoFirmaProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoDocumentoFirma });
            });

        }

    });

}

export const AgregarTipoDocumentoFirma = ( params: TipoDocumentoFirmaProps ) => {

    return new Promise<TipoDocumentoFirmaProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoDocumentoFirma/Agregar', params, token)
            .then( ({ data } : { data : TipoDocumentoFirmaProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoDocumentoFirma });
            });

        }

    });

}
